import { useState, useEffect } from "react"
import {
    Row,
    Col,
    Container,
    Form,
    FormGroup,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Input,
    Spinner,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle
} from "reactstrap";
import { RoundedButton, ButtonColor, ButtonCorner } from "../../components/Buttons/RoundedButton";
import PropTypes from 'prop-types';
import states from "../../constants/states";
import Select from "react-select";
import { languages } from "../../constants/languages";
import PostalZipCodeControl from "../Addresses/PostalZipCodeControl";
function OrganizationCRUModal(
    {
        isOpen,
        isLoading,
        submitHandler,
        data,
        toggle,
        languageOptions
    }
) {

    const [language, setLanguage] = useState(data?.defaultLanguages?.[0] ?? languages.English);
    const [languageText, setLanguageText] = useState(data?.languageText ?? "English");
    const [addressState, setAddressState] = useState(data?.addresses[0]?.state);
    const [dropdownDisplayed, setDropDownDisplayed] = useState(false);

    useEffect(() => {
        setLanguageText(data?.languageText ?? "English");
    }, [data])

    function dropDownToggle() {
        setDropDownDisplayed(!dropdownDisplayed);
    }
    function handleChange(event) {
        setLanguage(event.target.value);
        setLanguageText(event.target.name);
        dropDownToggle();
    }

    function handleAddressStateChange(event) {
        setAddressState(event.target.value)
    }

    return (
        <Modal size='lg' isOpen={isOpen} toggle={toggle} backdrop="static">
            <ModalHeader >
                Manage a Location 📳
            </ModalHeader>
            <ModalBody>
                {isLoading &&
                    <Spinner className="centered-loader"></Spinner>
                }

                {!isLoading &&
                    <Form onSubmit={submitHandler}>
                        <>
                            <input type="hidden" id="id" value={data?.addresses[0]?.id} />


                            <FormGroup row>
                                <Label
                                    for="name"
                                    sm={2}
                                >
                                    Location Name<span className="required-indicator">*</span>
                                </Label>
                                <Col sm={10}>
                                    <Input
                                        className="modal-input"
                                        id="name"
                                        required
                                        defaultValue={data?.name}
                                    />

                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label
                                    for="location"
                                    sm={2}
                                >
                                    Location
                                </Label>
                                <Col sm={10}>
                                    <Input
                                        className="modal-input"
                                        id="location"
                                        defaultValue={data?.location}
                                    />

                                </Col>
                            </FormGroup>


                            <FormGroup row>

                                <Label
                                    for="accountId"
                                    sm={2}
                                >
                                    Account Id
                                </Label>
                                <Col sm={10}>
                                    <Input
                                        className="modal-input"
                                        id="accountId"
                                        placeholder=""
                                        readOnly
                                        disabled
                                        value={data?.accountId}

                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label
                                    for="address1"
                                    sm={2}
                                >
                                    Address 1<span className="required-indicator">*</span>
                                </Label>
                                <Col sm={10}>
                                    <Input
                                        className="modal-input"
                                        id="address1"
                                        required
                                        defaultValue={data?.addresses[0]?.address1}

                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label
                                    for="address2"
                                    sm={2}
                                >
                                    Address 2
                                </Label>
                                <Col sm={10}>
                                    <Input
                                        className="modal-input"
                                        id="address2"
                                        defaultValue={data?.addresses[0]?.address2}

                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label
                                    for="city"
                                    sm={2}
                                >
                                    City<span className="required-indicator">*</span>
                                </Label>
                                <Col sm={10}>
                                    <Input
                                        className="modal-input"
                                        id="city"
                                        required
                                        defaultValue={data?.addresses[0]?.city}

                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label
                                    id="state-label"
                                    data-testid="State"
                                    sm={2}
                                >
                                    State<span className="required-indicator">*</span>
                                </Label>
                                <Col sm={10}>
                                    <div data-testid="select-state">
                                        <Select
                                            inputId="state-select"        // stable input ID
                                            instanceId="state-select" 
                                            id="state"
                                            name="state"
                                            onChange={opt => handleAddressStateChange({
                                                target: {
                                                    id: 'state',
                                                    value: opt.value
                                                }
                                            })}
                                            required
                                            //className="react-select"
                                            defaultValue={states.find(opt => opt.value === (data?.addresses[0]?.state || addressState))}
                                            options={states}
                                        />
                                    </div>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label

                                    for="zip"
                                    sm={2}
                                >
                                    Postal Code<span className="required-indicator">*</span>
                                </Label>
                                <Col sm={10}>
                                    <PostalZipCodeControl 
                                        id="zip"
                                        name="zip"
                                        required = {true}
                                        region={data?.addresses[0]?.country || "US"}
                                        onChange={(event) => {
                                            //setPostalCode(event.target.value);
                                        }}
                                        className="modal-input"
                                        defaultValue={data?.addresses[0]?.zip}
                                    />
                                    {/* <Input
                                        className="modal-input"
                                        id="zip"
                                        required
                                        defaultValue={data?.addresses[0]?.zip}
                                    /> */}
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label

                                    for="phone"
                                    sm={2}
                                >
                                    Phone #
                                </Label>
                                <Col sm={10}>
                                    <Input
                                        className="modal-input"
                                        pattern={'\\d\\d\\d-\\d\\d\\d-\\d\\d\\d\\d'}
                                        id="phone"
                                        title="Please enter in the format of xxx-xxx-xxxx"
                                        defaultValue={data?.phone}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label

                                    
                                    sm={2}
                                >
                                    Default Language
                                </Label>
                                <Col sm={10}>
                                    <Input id="language" type="hidden" value={language}></Input>
                                    <Dropdown toggle={dropDownToggle} isOpen={dropdownDisplayed}>
                                        <DropdownToggle caret>
                                            {languageText}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {
                                                languageOptions.map((item, index) => {
                                                    return (
                                                        <DropdownItem key={item.id} name="English" value={item.id} onClick={handleChange} >
                                                            {item.value}
                                                        </DropdownItem>
                                                    )
                                                }) 
                                            }
                                        </DropdownMenu>
                                    </Dropdown>
                                </Col>
                            </FormGroup>
                            <Container>
                                <Row>
                                    <Col />
                                    <Col />
                                    <Col />
                                    <Col />
                                    <Col />
                                    <Col>
                                        <RoundedButton
                                            id="cancelButton"
                                            hoverColor={ButtonColor.DarkGrey}
                                            hoverTextColor={ButtonColor.White}
                                            hoverOutlineColor={ButtonColor.DarkGrey}
                                            textColor={ButtonColor.White}
                                            buttonColor={ButtonColor.Grey}
                                            outlineColor={ButtonColor.Grey}
                                            cornerRadius={ButtonCorner.TenPX}
                                            text="Cancel"
                                            clickHandler={toggle} />
                                    </Col>
                                    <Col>
                                        <RoundedButton
                                            id="saveChangesButton"
                                            hoverColor={ButtonColor.Black}
                                            hoverTextColor={ButtonColor.White}
                                            hoverOutlineColor={ButtonColor.Black}
                                            textColor={ButtonColor.White}
                                            buttonColor={ButtonColor.DarkBlue}
                                            outlineColor={ButtonColor.DarkBlue}
                                            cornerRadius={ButtonCorner.TenPX}
                                            text="Save Changes"
                                            type="submit"
                                            width="160px"
                                        />
                                    </Col>
                                </Row>
                            </Container>
                        </>
                    </Form>
                }
            </ModalBody>
            <ModalFooter>
            </ModalFooter>
        </Modal>
    )


}

OrganizationCRUModal.propTypes =
{
    isOpen: PropTypes.bool,
    isLoading: PropTypes.bool,
    submitHandler: PropTypes.func,
    data: PropTypes.object,
    toggle: PropTypes.func,
    languageOptions: PropTypes.array
}
export default OrganizationCRUModal;